import { UnableToConnectException, NotFoundException, AuthenticationException } from '../exceptions';
import { selectors as appSelectors, actions as appActions } from '../../modules/appModule';
import config from '../../config.out.json';

let store; // cant import store directly because it would be circular
export function setStore(_store) {
  store = _store;
}

function kickOutUser() {
  store.dispatch(appActions.logout());
}

function getAuthHeader() {
  return 'Bearer ' + appSelectors.getAuthToken(store.getState().app);
}

async function request(path, settings) {
  let response;
  try {
    response = await fetch(`//${config.api}${path}`, settings);
  } catch (e) {
    console.log(e);
    throw new UnableToConnectException('Unable to connect to server.');
  }

  const getErrorMessage = async () => {
    try {
      return (await response.json()).message;
    } catch {
      return undefined;
    }
  }

  if (response.status === 401) {
    if (path !== '/auth/login') kickOutUser();
    throw new AuthenticationException(await getErrorMessage());
  }
  if (response.status === 404) throw new NotFoundException(await getErrorMessage());
  if (response.status === 500) throw new UnableToConnectException(await getErrorMessage());

  return response;
}

export async function get(path) {
  return await request(path, {
    headers: {
      Authorization: getAuthHeader()
    }
  });
}

export async function post(path, body) {
  return await request(path, {
    method: 'POST',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      Authorization: getAuthHeader()
    },
    body: JSON.stringify(body)
  });
}

export async function postFile(path, file) {
  const formData = new FormData();
  formData.append('file', file);

  return await request(path, {
    method: 'POST',
    headers: {
      Accept: 'application/json, text/plain, */*',
      Authorization: getAuthHeader()
    },
    body: formData
  });
}

export async function del(path) {
  return await request(path, {
    method: 'DELETE',
    headers: {
      Authorization: getAuthHeader()
    }
  });
}

export async function put(path, body) {
  return await request(path, {
    method: 'PUT',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      Authorization: getAuthHeader()
    },
    body: JSON.stringify(body)
  });
}

